import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import React from 'react';
import SignInPage from './pages/sign-in-page/SignInPage';
import RegisterPage from './pages/register-page/RegisterPage';
import DashboardPage from './pages/dashboard-page/DashboardPage';
import DeviceDetailPage from './pages/device-detail-page/DeviceDetailPage';
import SummaryDevicePage from './pages/device-detail-page/summary-device-page/SummaryDevicePage';
import HistoricDevicePage from './pages/device-detail-page/historic-device-page/HistoricDevicePage';
import ChatPage from './pages/chat-page/ChatPage';
import DevicePage from './pages/device-page/DevicePage';

export const defaultPath = '/';
export const signInPath = '/sign-in';
export const registerPath = '/sign-up';
export const dashboardPath = '/dashboard';
export const chatPath = 'chat';
export const devicePath = 'device';
export const devicesPath = 'devices';
export const summaryDevicePath = 'summary';
export const historicDevicePath = 'historic';

const routes: RouteObject[] = [
  {
    path: defaultPath,
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Navigate to={signInPath} replace />,
      },
      {
        path: signInPath,
        element: <SignInPage />,
      },
      {
        path: registerPath,
        element: <RegisterPage />,
      },
      {
        path: `${dashboardPath}`,
        element: <DashboardPage />,
        children: [
          {
            path: chatPath,
            element: <ChatPage />,
          },
          {
            path: devicesPath,
            element: <DevicePage/>,
          },
          {
            path: `${devicePath}/:deviceUuid`,
            element: <DeviceDetailPage />,
            children: [
              {
                path: summaryDevicePath,
                element: <SummaryDevicePage />,
              },
              {
                path: historicDevicePath,
                element: <HistoricDevicePage />,
              },
            ],
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
];

export default routes;
